import React, { useContext, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import type { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

import type { ILayoutConsumerState } from './LayoutContext';
import { LayoutContext } from './LayoutContext';

const useStyles = makeStyles((theme: Theme) => ({
    main: {
        paddingTop: theme.topbar.height + theme.spacing(6),
        paddingBottom: '40px',
    },
    centered: {
        alignItems: 'center',
    },
}));

interface IMainProps {
    decorate?: boolean;
    withoutSidebar?: boolean;
    withoutHeader?: boolean;
    withoutFooter?: boolean;
    centered?: boolean;
    fullScreen?: boolean;
    children?: React.ReactNode;
}

export const Main: React.FC<IMainProps> = ({
    decorate = false,
    withoutSidebar = false,
    withoutHeader = false,
    withoutFooter = false,
    centered = false,
    fullScreen = false,
    children,
}) => {
    const classes = useStyles();
    const context = useContext(LayoutContext) as ILayoutConsumerState | null;

    useEffect(() => {
        // Scroll to top when component mounts (new view loads)
        window.scrollTo(0, 0);

        if (!context) return;

        const {
            setDecorate,
            setWithoutSidebar,
            setWithoutHeader,
            setWithoutFooter,
            setFullScreen,
        } = context;

        if (setDecorate) {
            setDecorate(!!decorate);
        }
        if (setWithoutSidebar) {
            setWithoutSidebar(!!withoutSidebar);
        }
        if (setWithoutHeader) {
            setWithoutHeader(!!withoutHeader);
        }
        if (setWithoutFooter) {
            setWithoutFooter(!!withoutFooter);
        }
        if (setFullScreen) {
            setFullScreen(!!fullScreen);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [decorate, withoutSidebar, withoutHeader, withoutFooter, fullScreen]);

    const classNames = classnames({
        [classes.main]: !fullScreen && !withoutHeader,
        [classes.centered]: centered,
    });

    return (
        <Grid item={true} className={classNames} xs={12}>
            {children}
        </Grid>
    );
};
